import { render } from "./bonusDetails.vue?vue&type=template&id=baef7f96&scoped=true"
import script from "./bonusDetails.vue?vue&type=script&lang=js"
export * from "./bonusDetails.vue?vue&type=script&lang=js"

import "./bonusDetails.vue?vue&type=style&index=0&id=baef7f96&lang=stylus"
import "./bonusDetails.vue?vue&type=style&index=1&id=baef7f96&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-baef7f96"]])

export default __exports__